/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/camelcase */
import SignerContext from '@/contexts/SignerContext';
import useInterval from '@/hooks/useInterval';
import { LoadingOutlined } from '@ant-design/icons';
import { Alert, Layout } from 'antd';
import axios from 'axios';
import classNames from 'classnames';
import ThemeContext from 'contexts/ThemeContext';
import React, { useContext, useEffect } from 'react';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import intl from 'react-intl-universal';
import { useLocation, withRouter } from 'react-router-dom';
import Loader from './Loader';
import styles from './style.module.scss';
import { LOCAL_WEB_API } from 'config';

const ThemeLayout = ({ children }: any) => {
  const location = useLocation();
  const [state] = useContext(ThemeContext);
  const [signerState, signerDispatch] = useContext(SignerContext);

  const ping = () => {
    axios
      .get(`${LOCAL_WEB_API}/health/ping`)
      .then((response) => {
        if (response.data === true && !signerState.localApiConnected) {
          signerDispatch({
            type: 'SET_LOCAL_API_CONNECTED',
            value: true
          });
        }

        if (response.data !== true && signerState.localApiConnected) {
          signerDispatch({
            type: 'SET_LOCAL_API_CONNECTED',
            value: false
          });
        }
      })
      .catch(() => {
        if (signerState.localApiConnected) {
          signerDispatch({
            type: 'SET_LOCAL_API_CONNECTED',
            value: false
          });
        }
      });
  };

  useInterval(ping, 2000);

  useEffect(() => {
    ping();
  }, []);

  return (
    <>
      <BlockUi
        tag="div"
        loader={<Loader spinning={false} fullScreen={false} />}
        blocking={!signerState.localApiConnected && (location.pathname === '/smartcardlogin' || location.pathname == '/create-account')}
        message={
          <Alert
            style={{ textAlign: 'left' }}
            className="custom-message"
            message={intl.get('BLOCK.MESSAGE')}
            description={intl.get('BLOCK.DESCRIPTION')}
            type="error"
            showIcon
            icon={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          />
        }
      >
        <div className={classNames({ air__layout__grayBackground: state.isGrayBackground })}>
          <Layout
            className={classNames({
              air__layout__contentNoMaxWidth: state.isContentNoMaxWidth,
              air__layout__appMaxWidth: state.isAppMaxWidth,
              air__layout__grayBackground: state.isGrayBackground,
              air__layout__squaredBorders: state.isSquaredBorders,
              air__layout__cardsShadow: state.isCardShadow,
              air__layout__borderless: state.isBorderless
            })}
          >
            <Layout>
              <div>
                <section
                  className={`${styles.login} ${styles.fullscreen}`}
                  style={{
                    backgroundImage: `url('resources/images/background/background.jpg')`
                  }}
                >
                  <header className={styles.header}>
                    <a className={styles.logo}>
                      <img
                        style={{ width: 250, marginLeft: '-75px', marginTop: 50, maxWidth: 'none' }}
                        src="resources/images/nes-beyaz-logo.svg"
                        alt="Clean UI Admin Template"
                      />
                    </a>
                    <h3 className={classNames(styles.h3, 'mt-3')}>{intl.get('MAIN.SIGNATURE_APPLICATION')}</h3>
                  </header>
                  <Layout.Content style={{ height: '100%', position: 'relative' }}>
                    <div className="air__utils__content">{children}</div>
                  </Layout.Content>
                </section>
              </div>
            </Layout>
          </Layout>
        </div>
      </BlockUi>
    </>
  );
};

export default withRouter(ThemeLayout);
